import React from "react"

const HeaderSectionRight = ({ data }) => {
  // Handle missing or invalid data
  if (!data || !data.images || !data.images.length) return null
  
  return (
    <div className="w-full md:w-[45%] lg:w-[45%] xl:w-[50%] flex flex-col items-center md:items-start xl:items-end md:justify-end mx-auto">
      <div className="w-full max-w-[350px] md:max-w-[350px] lg:max-w-[450px] xl:max-w-[600px] aspect-671/940 md:pt-[50px] xl:pt-6 lg:mt-0">
        <img src={data.images[0]} alt="Android Device" className="w-full h-auto" />
      </div>
    </div>
  )
}

export default HeaderSectionRight
